import { useState, useEffect } from 'react';
import { ConnectionQuality, RoomEvent } from 'livekit-client';
import { useRoomContext } from '@livekit/components-react';

export const useConnectionQuality = () => {
  const room = useRoomContext();
  const [quality, setQuality] = useState<ConnectionQuality>(ConnectionQuality.Unknown);

  useEffect(() => {
    const handleQualityChanged = (quality: ConnectionQuality) => {
      setQuality(quality);
    };

    room.on(RoomEvent.ConnectionQualityChanged, handleQualityChanged);

    if (room.localParticipant?.connectionQuality) {
      setQuality(room.localParticipant.connectionQuality);
    }

    return () => {
      room.off(RoomEvent.ConnectionQualityChanged, handleQualityChanged);
    };
  }, [room]);

  return quality;
};
